import React, { createContext, useContext } from 'react';
import { DEFAULT_DOMAIN, DOMAINS } from '../../../constants';

type Domain = (typeof DOMAINS)[keyof typeof DOMAINS];

export const DomainContext = createContext<Domain>(DEFAULT_DOMAIN);

interface DomainProps {
  value: Domain;
  children: React.ReactNode;
}

export const Domain = ({ value, children }: DomainProps) => (
  <DomainContext.Provider value={value}>{children}</DomainContext.Provider>
);

export const useDomain = () => useContext(DomainContext);
